import { Checkbox, TableRow, Theme } from '@mui/material';
import { lighten } from '@mui/material/styles';
import shortid from 'shortid';
import { makeStyles } from 'tss-react/mui';

import LPTableCell from '../LPTableCell';
import LPLink from '../LPLink';
import { colors } from '../../../utils/theme';

const useStyles = makeStyles<{ isDetailView?: boolean }>()((theme: Theme, props) => ({
  active: {
    backgroundColor: colors.paleGrey,
  },
  body: {
    border: 'none',
  },
  highlighted: {
    backgroundColor: lighten(colors.paleGrey, 0.4),
  },
  root: {
    borderBottom: props.isDetailView ? 'none' : '1px solid #114fa7',
    '&:hover': {
      backgroundColor: colors.paleGrey,
      cursor: 'pointer',
    },
  },
  tableCell: {
    padding: '16px !important',
  },
  transitionEffect: {
    animation: '$highlight 2000ms cubic-bezier(0.4, 0, 0.2, 1)',
  },
  '@keyframes highlight': {
    '0%': {
      backgroundColor: lighten(theme.colors.peacockBlue, 0.4),
    },
    '100%': {
      backgroundColor: 'none',
    },
  },
}))

export const LPTableRowMain = props => {
  const { classes, cx } = useStyles(props);
  const {
    row,
    headers,
    isDetailView = false,
    isNew,
    selectable = false,
    showDetailView,
    keyIdentifier,
    handleClick,
    checked,
    onSelect,
  } = props;

  return (
    <TableRow
      className={cx(classes.root, {
        [classes.active]: showDetailView,
        [classes.highlighted]: isDetailView,
        [classes.transitionEffect]: isNew,
      })}
      onClick={e => handleClick(e)}
    >
      {selectable && (
        <LPTableCell showBorder={showDetailView}>
          <Checkbox checked={checked} onChange={e => onSelect(e, row[keyIdentifier])} />
        </LPTableCell>
      )}

      {headers
        .map(h => h.keyOrGetter)
        .map((attribute, i) => {
          const value =
            typeof attribute === 'function'
              ? attribute(row)
              : attribute === ''
              ? ''
              : row[attribute];

          const CustomComponent = () => (headers[i].Component ? headers[i].Component(row) : null);

          return (
            <LPTableCell className={classes.tableCell} showBorder={showDetailView} key={shortid.generate()}>
              {headers[i].Component ? (
                <CustomComponent />
              ) : headers[i].path ? (
                <LPLink to={headers[i].path(row)}>{value}</LPLink>
              ) : value ? (
                value.toString()
              ) : (
                ''
              )}
            </LPTableCell>
          );
        })}
    </TableRow>
  );
};
